export function removeSeconds(time = '') {
    return time.replace(/(\d{1,2}):(\d{1,2}):(\d{1,2})/, "$1:$2");
}
